export { DeesThumbnailBase } from './DeesThumbnailBase.js';
export { thumbnailBaseStyles } from './styles.js';
